/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Weighing_DateInputs */

const vi_trace_weighing_date = /** @type {(inputs: Trace_Weighing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cân`)
};

/**

* @param {Trace_Weighing_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_weighing_date = /** @type {((inputs?: Trace_Weighing_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Weighing_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_weighing_date(inputs)
});